import { getUserToken } from "../helpers/authHelper";
import api from "../api";

export async function FetchSelectedList(payload) {
  return await api({
    method: "get",
    params: payload,
    url: `${process.env.REACT_APP_API_URL}/admin/selected/selected-list`,
    headers: {
      Authorization: getUserToken(),
      "X-DomainID": localStorage.getItem("subdomainId") || "",
      "X-lang_id": localStorage.getItem("lang_id") || "",
    },
  });
}
